import { IInteractionCategory } from '../../../APIPackage/CatalogsModule/interfaces/IInteractionCategory';
import { IInteractionCategorySelectOption } from '../interfaces/IInteractionCategorySelectOption';

export const createInteractionCategorySelectOption = (
  category: IInteractionCategory,
): IInteractionCategorySelectOption => ({
  ...category,
  label: category.name,
  value: category.id,
});
